'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchingIndustries = exports.fetchingOccupations = exports.industriesError = exports.occupationsError = exports.industries = exports.occupations = exports.employmentLookup = undefined;
var _constants = require('../constants');
var employmentLookup = exports.employmentLookup = function employmentLookup(state, formId) {
  return state[_constants.NAME][formId] ? state[_constants.NAME][formId].employmentLookup : {};
};
var occupations = exports.occupations = function occupations(state, formId) {
  return employmentLookup(state, formId).occupations;
};
var industries = exports.industries = function industries(state, formId) {
  return employmentLookup(state, formId).industries;
};
var occupationsError = exports.occupationsError = function occupationsError(state, formId) {
  return employmentLookup(state, formId).occupationsError;
};
var industriesError = exports.industriesError = function industriesError(state, formId) {
  return employmentLookup(state, formId).industriesError;
};
var fetchingOccupations = exports.fetchingOccupations = function fetchingOccupations(state, formId) {
  return employmentLookup(state, formId).fetchingOccupations;
};
var fetchingIndustries = exports.fetchingIndustries = function fetchingIndustries(state, formId) {
  return employmentLookup(state, formId).fetchingIndustries;
};